import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { SonicTermData } from "../../common/classes/SonicTerm";
import SelectTermModal from "../../common/forms/SelectTermModal";
import styles from "./GameRelatedSearch.module.scss";
import SonicLink from "../../common/routing/SonicLink";

type Props = {
  modalLoading: boolean;
  games: Array<SonicTermData>;
  selectedGame?: SonicTermData;
  handleSearch: (game: SonicTermData) => void;
  handleSearchOption: (keyword: string) => void;
  children: React.ReactNode;
};
const GameRelatedSearch: React.FC<Props> = ({
  modalLoading,
  games,
  selectedGame,
  handleSearch,
  handleSearchOption,
  children,
}) => {
  const [isModalShown, setIsModalShown] = useState<boolean>(false);

  const setModal = (value: boolean) => {
    const html = document.querySelector("html");
    if (html) {
      html.style.overflowY = value ? "hidden" : "unset";
    }

    setIsModalShown(value);
  };

  useEffect(() => {
    return () => {
      const html = document.querySelector("html");
      if (html) {
        html.style.overflowY = "unset";
      }
    };
  }, []);
  return (
    <>
      <div className={`${styles["s-game"]} ${styles["right"]}`}>
        <button
          type="button"
          onClick={() => {
            setModal(true);
          }}
          className={`${styles["s-game__btn"]} ${styles["no-border"]}`}
        >
          <FontAwesomeIcon icon={["fal", "search"]} />
          <span>ゲームを選ぶ</span>
        </button>
      </div>
      {children}
      <div className={`${styles["s-game"]} ${styles["center"]}`}>
        <button
          type="button"
          onClick={() => {
            setModal(true);
          }}
          className={styles["s-game__btn"]}
        >
          <FontAwesomeIcon icon={["fal", "search"]} />
          <span>ゲームを選ぶ</span>
        </button>
      </div>
      <SelectTermModal
        isModalShown={isModalShown}
        isLoading={modalLoading}
        termName="ゲーム"
        handleSearch={handleSearchOption}
        handleClose={() => setModal(false)}
        handleSelect={(value: SonicTermData) => {
          handleSearch(value);
          setModal(false);
        }}
        selectedTerm={selectedGame}
        options={games}
        helpLink={
          <SonicLink to="/contact" newTab={true}>
            {`ご希望のゲームがない方はこちら`}
          </SonicLink>
        }
      />
    </>
  );
};

export default GameRelatedSearch;
